import { useRef, useState } from "react";
import { Search } from "lucide-react";

// Hover-to-magnify image: a zoomed overlay of the same image follows the cursor.
export default function MagnifierImage({ src, alt, zoom = 2.4, className = "", imgClassName = "w-full h-full object-contain" }) {
  const ref = useRef(null);
  const [show, setShow] = useState(false);
  const [pos, setPos] = useState({ x: 50, y: 50 });

  const onMove = (e) => {
    const r = ref.current.getBoundingClientRect();
    const x = Math.min(100, Math.max(0, ((e.clientX - r.left) / r.width) * 100));
    const y = Math.min(100, Math.max(0, ((e.clientY - r.top) / r.height) * 100));
    setPos({ x, y });
  };

  return (
    <div
      ref={ref}
      data-testid="magnifier-image"
      className={`relative overflow-hidden cursor-zoom-in ${className}`}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
      onMouseMove={onMove}
    >
      <img src={src} alt={alt} className={imgClassName} />
      {show && (
        <div
          className="pointer-events-none absolute inset-0 hidden sm:block"
          style={{
            backgroundImage: `url(${src})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: `${zoom * 100}%`,
            backgroundPosition: `${pos.x}% ${pos.y}%`,
          }}
        />
      )}
      {!show && (
        <div className="absolute bottom-2 left-2 bg-ink/70 text-paper p-1.5 border border-stroke hidden sm:flex items-center gap-1 pointer-events-none">
          <Search size={12} />
          <span className="font-mono text-[9px] uppercase tracking-wider">Hover to zoom</span>
        </div>
      )}
    </div>
  );
}
